import { render, staticRenderFns } from "./AddStorage.vue?vue&type=template&id=f3fb3134&"
import script from "./AddStorage.vue?vue&type=script&lang=js&"
export * from "./AddStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports